
import React from 'react';
import BusRatesTable from './BusRatesTable';
import VehicleList from '../componets/VehicleList';


const Packages = () => {
  return (
   <div>


  <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  Packages
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





       

<VehicleList/>

    {/* <CabRatesTable/> */}
<BusRatesTable/>

<div className="rules-guidelines container">
  <h2>Rules and Guidelines:</h2>
  {/* <ul className="rules-list">
  <li>  Driver Allowance will charge extra.</li>
  <li>  Cab running km is limited to 300 km per day.</li>
  <li>  Time starts from 6:00 AM to 10:00 PM, and the cab must be free at 10:00 PM. After 10:00 PM, extra charges apply. Night charges apply from 12:00 AM to 6:00 AM.</li>
  <li>  Time and km will be calculated from our office to office.</li>
  <li>  Interstate taxes, toll taxes, parking, and service tax are charged as actuals.</li>
  <li>  Extra charges will apply for extra km and hours. Government taxes will be charged as per government rules.</li>
  <li>  The charges quoted above are calculated based on the current fuel prices. Any hike in fuel prices will result in a variation in rates.</li>
</ul> */}
  <div className="rules-section">
  {/* <h4 className="rules-title">Rules and Guidelines</h4> */}
{/* 
  <ul className="rules-list">
    <li>Driver Allowance will charge extra.</li>
    <li>Cab running km is limited to 300 km per day.</li>
    <li>
      Time starts from 6:00 AM to 10:00 PM, and the cab must be free at 10:00 PM.
      After 10:00 PM, extra charges apply. Night charges apply from 12:00 AM to
      6:00 AM.
    </li>
    <li>Time and km will be calculated from our office to office.</li>
    <li>
      Interstate taxes, toll taxes, parking, and service tax are charged as
      actuals.
    </li>
    <li>
      Extra charges will apply for extra km and hours. Government taxes will be
      charged as per government rules.
    </li>
    <li>
      The charges quoted above are calculated based on the current fuel prices.
      Any hike in fuel prices will result in a variation in rates.
    </li>
  </ul> */}
<ul className="rules-list">
  <li>Full tolls, parking, passenger tax, GST, and special permit costs must be paid by the party.</li>
  <li>Taxes of other states (outside Maharashtra) are to be paid by the party.</li>
  <li>Time and meter readings will be calculated from parking to parking.</li>
  <li>For a trip, the average daily distance allowed is 300 km. Different rates apply for the Mumbai–Mahabaleshwar route (Mumbai package allows 350 km).</li>
  <li>Provide a list of passengers' names and travel destinations and submit it to the office at least four days before departure.</li>
  <li>The bus service will be available from 6:00 AM to 12:00 midnight.</li>
  <li>If usage extends beyond 12:00 midnight, an additional charge of Rs. 400 per hour will apply until 2:00 AM, after which the full 300 km rate for the next day will be charged.</li>
  <li>If using the bus with air conditioning, an extra charge of Rs. 500 per hour will apply.</li>
  <li>At the time of booking, 50% of the total amount along with a security deposit must be paid at least 2 days before the trip.</li>
  <li>If a booking is canceled suddenly, 50% of the total amount will be charged as a cancellation fee.</li>
  <li>Rates are based on current diesel prices (Rs. 100 per liter) and may change according to R.T.O. taxes.</li>
  <li>Bus tolls will be deducted via FASTag, and the full toll amount must be paid during settlement.</li>
  <li>We provide clean, well-maintained vehicles and responsible drivers. For complaints, contact: 9595532929.</li>
  <li>There are no hidden or extra charges.</li>
</ul>
  <h2>नियम व अटी</h2>

<ul className="rules-list">
  <li>संपूर्ण टोल, पार्किंग, प्रवासी कर, जी.एस.टी. आणि स्पेशल परमिटचा खर्च पार्टीने द्यावयाचा आहे.</li>
  <li>इतर राज्यांचे कर (महाराष्ट्राबाहेरील) पार्टीने भरावयाचा आहे. (राज्यांप्रमाणे)</li>
  <li>वेळ व मीटर रिडींग पार्किंग ते पार्किंग असेल.</li>
  <li>ट्रीपसाठी प्रति दिवस ३०० कि.मी. अॅव्हरेज राहील / मुंबई-महाबळेश्वरचे दर वेगळे राहतील. (मुंबई करिता पॅकेज ३५० कि.मी.)</li>
  <li>प्रवाशांच्या नावांची यादी व प्रवासाची ठिकाणे व्यवस्थित नमूद करून किमान ४ दिवस अगोदर ऑफिसमध्ये जमा करावी.</li>
  <li>बस वापरण्याचा कालावधी पहाटे ६.०० ते रात्री १२.०० पर्यंत राहील.</li>
  <li>जर रात्री १२.०० नंतर बसचा वापर झाल्यास पुढील प्रत्येक तासाला रु. ४००/- आकार पडेल. ही मुदत पहाटे २.०० पर्यंत असेल व त्यानंतर आल्यास दुसऱ्या दिवसाचा संपूर्ण ३०० कि.मी. चा आकार पडेल.</li>
  <li>ए.सी. बस पार्किंग असताना बसचा ए.सी. चालू केल्यास प्रत्येक तासाला रु. ५००/- वेगळा चार्ज द्यावा लागेल.</li>
  <li>बस बुक करतेवेळेस ५०% अनामत व उर्वरित रक्कम बस ट्रीपला जाण्याच्या २ दिवस अगोदर भरावयाची आहे.</li>
  <li>अचानक बुकिंग कॅन्सल केल्यास संपूर्ण रकमेच्या ५०% रक्कम भरावी लागेल.</li>
  <li>वरील दिलेले दर हे सध्या चालू स्थितीतील डिझेलच्या किंमतीनुसार (रु. १००.०० प्रति लीटर) तसेच आर.टी.ओ.च्या सध्यस्थितीतील टॅक्सनुसार आहेत.</li>
  <li>बसचा टोल FASTag वरून कापला जाईल त्यामुळे तुम्हाला संपूर्ण पेमेंट प्रक्रियेदरम्यान टोल शुल्काची रक्कम भरावी लागेल.</li>
  <li>आम्ही आमचे सर्वोत्तम देण्याचा प्रयत्न करतो जसे की चांगल्या दर्जाची वाहने उपलब्ध करून देणे आणि ड्रायव्हर स्वच्छ, चांगले कपडे घातलेला व मद्यपान न करणारा असेल. काही तक्रार असल्यास त्वरित संपर्क साधा: 9595532929.</li>
  <li>कोणतेही छुपे अतिरिक्त शुल्क नाही.</li>
</ul>

</div>

</div>

   </div>
  );
};

export default Packages;
